import React from 'react';
import { useNavigate } from 'react-router-dom';

function PromoBoxes() {
  const navigate = useNavigate();

  const boxes = [
    { title: 'Horarios', link: '/horarios', color: '#fff', text: '#000', desc: 'RESERVA TU FECHA' },
    { title: 'Paquetes', link: '/paquetes', color: '#FFD700', text: '#000', desc: 'PLANES A TU MEDIDA' },
    { title: 'DJ', link: '/dj', color: '#000', text: '#fff', desc: 'TALENTO EN VIVO' },
  ];

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%' }}>
      {boxes.map((box, index) => (
        <div 
          key={index} 
          onClick={() => navigate(box.link)}
          style={{ 
            flex: '1 1 33.33%', 
            height: '450px',
            backgroundColor: box.color,
            color: box.text,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            transition: '0.3s',
            border: box.color === '#000' ? '1px solid #333' : 'none'
          }}
          onMouseOver={(e) => e.currentTarget.style.transform = 'scale(0.98)'}
          onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          <h2 style={{ fontSize: '40px', fontWeight: '900', margin: '0', textTransform: 'uppercase' }}>
            {box.title}
          </h2>
          <p style={{ letterSpacing: '3px', fontSize: '12px', marginTop: '10px' }}>{box.desc}</p>
          <div style={{ 
            marginTop: '30px', 
            fontSize: '30px', 
            width: '60px', 
            height: '60px', 
            borderRadius: '50%', 
            border: `2px solid ${box.text}`,
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>+</div>
        </div>
      ))}
    </div>
  );
}

export default PromoBoxes;